import type React from 'react';
import { useTranslation } from 'react-i18next';

type InvalidContentProps = {
  column: string;
  content: number[] | { index: number; url: string }[];
};

const InvalidContentDisplay: React.FC<InvalidContentProps> = ({
  column,
  content,
}) => {
  const { t } = useTranslation();

  if (!Array.isArray(content)) {
    return <></>;
  }

  return (
    <div className='flex flex-col font-mono text-pico text-white bg-primary-base py-2 px-3 gap-0.5 h-auto'>
      {column !== 'urls'
        ? `${t('data-sources.invalid-data-source-content.row-indexes')}: ${content.join(', ')}`
        : (content as { index: number; url: string }[]).map((item) => (
            <div key={item.index}>
              {`${t('data-sources.invalid-data-source-content.row-index')}: ${item.index} - ${t('data-sources.invalid-data-source-content.value')}: "${item.url}"`}
            </div>
          ))}
    </div>
  );
};

export default InvalidContentDisplay;
